module.exports = __webpack_public_path__ + "img/clipboard.ff0516ce.svg";